import { ReactComponent as CloseCorporationIcon } from '../icons/close-corporation.svg';
import { ReactComponent as CoOperativeIcon } from '../icons/co-operative.svg';
import { ReactComponent as NonProfitIcon } from '../icons/non-profit.svg';
import { ReactComponent as PartnershipIcon } from '../icons/partnership.svg';
import { ReactComponent as PrivateCompanyIcon } from '../icons/private-company.svg';
import { ReactComponent as PublicCompanyIcon } from '../icons/public-company.svg';
import { ReactComponent as SoleProprietorIcon } from '../icons/sole-proprietor.svg';
import { ReactComponent as StateOwnedIcon } from '../icons/state-owned.svg';
import { ReactComponent as TrustIcon } from '../icons/trust.svg';

const COMPANY_TYPES = [
  {
    key: 'sole-proprietor',
    label: 'Sole Proprietor',
    value: 'sole-proprietor',
    icon: SoleProprietorIcon,
    active: true
  },
  {
    key: 'partnership',
    label: 'Partnership',
    value: 'partnership',
    icon: PartnershipIcon
  },
  {
    key: 'private-company',
    label: 'Private Company',
    value: 'private-company',
    icon: PrivateCompanyIcon
  },
  {
    key: 'public-company',
    label: 'Public Company',
    value: 'public-company',
    icon: PublicCompanyIcon
  },
  {
    key: 'non-profit-company',
    label: 'Non-Profit Company',
    value: 'non-profit-company',
    icon: NonProfitIcon
  },
  {
    key: 'state-owned-company',
    label: 'State-Owned Company',
    value: 'state-owned-company',
    icon: StateOwnedIcon
  },
  {
    key: 'close-corporation',
    label: 'Close Corporation',
    value: 'close-corporation',
    icon: CloseCorporationIcon
  },
  { key: 'trust', label: 'Trust', value: 'trust', icon: TrustIcon },
  { key: 'co-operative', label: 'Co-operative', value: 'co-operative', icon: CoOperativeIcon }
];

export const ACTIVE_COMPANY_TYPES = COMPANY_TYPES.filter((type) => type.active);
